import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { CookingDto } from "./cooking.dto";

export class GetCookingInfoResponse extends GlobalResponseObject {
    data?: CookingDto[];
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: CookingDto[]) {
        super(status, intlCode, internalMessage)
        this.data = data;
    }
}